import fireAnalytics from '@sls-react/services/analytics/fireAnalytics';

export const fireVisitedTradeInEventsPage = () =>
  fireAnalytics('Visited Trade-in Events');
